module.exports = __webpack_public_path__ + "img/m-item06.50f371d.png";